// extracted by mini-css-extract-plugin
export default {"content":"St5qnchi9OHc21K5Hb37UQ==","text":"xpe93swli-ynO-dM9JX9vQ==","restoreNotice":"e3D0sl5oJr1suXn6JSf22A==","buttonHolder":"m6qZnKRT--heA7xt4CVewA=="};